import React from "react";
import { socketConnected, socketReconnecting, socketError, textDark } from "../../config/colors";

// Ambang latency socket ke server Caready (ms). Sama dengan aplikasi mobile.
export const LATENCY_GOOD_MS = 150;
export const LATENCY_SLOW_MS = 400;

const latencyLevel = (ms) => {
  if (ms < LATENCY_GOOD_MS) return { text: "Koneksi Stabil", color: socketConnected };
  if (ms < LATENCY_SLOW_MS) return { text: "Koneksi Lambat", color: socketReconnecting };
  return { text: "Koneksi Jelek", color: socketError };
};

/**
 * Badge latency koneksi socket ke server, dari event "pong" socket.io
 * (client ping ke server tiap ±20 dtk, tanpa request tambahan).
 * Tampil hanya saat terhubung dan sudah ada hasil ukur.
 */
const ConnectionLatency = ({ latencyMs }) => {
  if (latencyMs === null || latencyMs === undefined) return null;
  const { text, color } = latencyLevel(latencyMs);

  return (
    <div
      style={{
        position: "fixed",
        top: "10px",
        right: "10px",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        background: "#fff",
        color: textDark,
        border: `1px solid ${color}`,
        padding: "4px 10px",
        borderRadius: "999px",
        fontSize: "12px",
        zIndex: 9999,
        boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
      }}
    >
      <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: color }} />
      {text} · {latencyMs} ms
    </div>
  );
};

export default ConnectionLatency;
